var DateSelectorMonth = (function (_classes, _eventHandler, _dsEventHandler) {
    var templateName = 'date-picker-months';
    var $el = $('<div role="monthSelector" class="date-selector-table date-selector-table__content">');

    var currentMonth;
    var currentMonthNumber;
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    var _changeMonth = function (month) {
        if (currentMonth !== month.value) {
            currentMonth = month.value;
            currentMonthNumber = month.num;
            $el.find('.' + _classes.selectedCell).removeClass(_classes.selectedCell);
            $el.find('@monthCell[data-value="' + currentMonth + '"]').addClass(_classes.selectedCell);
        }
    }

    var _subscribe = function () {
        $el.find('@monthCell').on('click', function () {
            var month = $(this).data('value');
            var num = $(this).data('num');
            var data = { value: month, num: num };
            _changeMonth(data);
            _eventHandler.trigger('changeMonth', data);
        });

        _dsEventHandler.onDisplay(function (e, display) {
            $el.toggleClass(_classes.hidden, display !== 'months');
        });
    };

    _eventHandler.on('changeMonth', function (e, month) {
        _changeMonth(month);
    });

    return {
        init: function () {
            $el.html($.tmpl(templateName, { Months: months }));
            currentMonth && $el.find('@monthCell[data-value="' + currentMonth + '"]').addClass(_classes.selectedCell);
            _subscribe();
        },
        appendTo: function ($container) {
            $container.append($el);
        },
        setMonth: function (value) {
            var num = value - 1;
            var month = months[num];
            var data = { value: month, num: num };
            _changeMonth(data);
            return data;
        },
        onChange: function (func) {
            _eventHandler.on('changeMonth', func);
        }
    }
});